var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({attrs:{"to":_vm.modifiedTo}},'router-link',Object.assign({}, _vm.$attrs, _vm.$props),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }